// Copy text to the clipboard. Uses the async Clipboard API in secure contexts and falls back to a
// hidden textarea + execCommand('copy') (older iOS Safari, http dev hosts). Must be called directly
// from a user gesture (click) — awaiting a request first makes Safari reject the write.
// Returns true on success.
export async function copyText(text) {
  const value = String(text ?? '');
  if (!value) return false;

  if (typeof navigator !== 'undefined' && navigator.clipboard && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(value);
      return true;
    } catch {
      // fall through to the legacy path
    }
  }
  return legacyCopy(value);
}

function legacyCopy(value) {
  if (typeof document === 'undefined') return false;
  const textarea = document.createElement('textarea');
  textarea.value = value;
  textarea.setAttribute('readonly', '');
  // Off-screen but selectable; 16px avoids the iOS zoom-on-focus.
  Object.assign(textarea.style, {
    position: 'fixed',
    top: '0',
    left: '0',
    width: '1px',
    height: '1px',
    opacity: '0',
    fontSize: '16px',
    pointerEvents: 'none',
  });

  const selection = document.getSelection();
  const previousRange = selection && selection.rangeCount > 0 ? selection.getRangeAt(0) : null;
  const previousFocus = document.activeElement;

  document.body.appendChild(textarea);
  textarea.select();
  textarea.setSelectionRange(0, value.length); // required on iOS

  let ok = false;
  try {
    ok = document.execCommand('copy');
  } catch {
    ok = false;
  }

  document.body.removeChild(textarea);
  if (previousRange && selection) {
    selection.removeAllRanges();
    selection.addRange(previousRange);
  }
  if (previousFocus && typeof previousFocus.focus === 'function') {
    previousFocus.focus({ preventScroll: true });
  }
  return ok;
}
